export default {"src":"/_next/static/media/no_news.823059e4.svg","height":150,"width":220};